import { Button, Typography } from '@mui/material';

import { ALLOW_SLIDER_ITEMS_PREFETCH } from '@/constants/prefetch';
import { ExternalLinkBanner } from '@/logic/services';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import Link from 'next/link';
import { pxToRem } from '@/theme/typography';

interface SliderExternalLinkInfoProps {
  primaryColor: string;
  externalLinkBanner: ExternalLinkBanner;
}

export const SliderExternalLinkInfo: FC<SliderExternalLinkInfoProps> = ({
  primaryColor,
  externalLinkBanner,
}) => {
  return (
    <>
      <Typography
        sx={{
          fontWeight: 700,
          fontFamily: 'co-head-line-corp-bold',
          lineHeight: pxToRem(35.13),
          color: primaryColor,
          marginBottom: pxToRem(24),
          marginX: {
            mobile: '32px',
            laptop: '0px',
          },
          fontSize: {
            tablet: pxToRem(30),
            mobile: '22px',
          },
          textAlign: {
            mobile: 'center',
            laptop: 'start',
          },
        }}
      >
        <FormattedMessage id='home_banner.explore' />
      </Typography>

      <Link href={externalLinkBanner.url} legacyBehavior
        passHref prefetch={ALLOW_SLIDER_ITEMS_PREFETCH}>
        <Button
          id={`slider-${externalLinkBanner.id}-btn`}
          variant='contained'
          component='a'
          target='_target'
          sx={{
            marginTop: pxToRem(16),
            paddingX: pxToRem(49),
            paddingY: pxToRem(18),
            fontFamily: 'co-head-line-corp-bold',
            borderRadius: pxToRem(16),
            height: { tablet: pxToRem(56), mobile: '56px' },
            fontSize: {
              mobile: '16px',
              tablet: pxToRem(16),
            },
            fontWeight: '700',
          }}
        >
          {externalLinkBanner.buttonText}
        </Button>
      </Link>
    </>
  );
};
